/**
 * ユーティリティ
 */

/**
 * モバイル端末の場合true
 * ※このフラグを利用してモバイル、デスクトップのレイアウトを切り替えることは禁止
 * @type {Boolean}
 */
export const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

/**
 * イベントバブリングを止める
 * @param {Event} e イベント
 */
export function stop (e) {
	e.stopPropagation()
}

/**
 * 指定された要素が非表示の場合true
 * @param {HTMLElement} el
 * @return {boolean}
 */
export function isHiddenEl (el) {
	return el.offsetParent === null
}

/**
 * 指定された要素がshadow domの場合、一番近い祖先のlight dom要素を取得する
 * @param {HTMLElement} el
 * @return {HTMLElement}
 */
export function findClosestLightElement (el) {
	const root = el.getRootNode()
	if (root instanceof ShadowRoot) {
		return findClosestLightElement(root.host)
	} else {
		return el
	}
}

/**
 * 文字列を日付に変換する.
 * @param {String} val 変換する日付文字列
 * @return {Date} 変換された日付
 */
export function parseToDate (val) {
	// 引数valがstring型でない場合nullを返す
	if (typeof val !== "string") return null

	// 文字列を年月日に分解
	const stringList = val.split("/")

	let year, month, day
	if (stringList.length === 3) {
		// スラッシュ区切りの場合
		year = stringList[0] - 0
		month = stringList[1] - 0
		day = stringList[2] - 0
	} else if (stringList.length === 1 && val.length === 8) {
		// スラッシュ区切りがなく8桁数値の場合
		year = val.substr(0, 4) - 0
		month = val.substr(4, 2) - 0
		day = val.substr(6, 2) - 0
	} else if (stringList.length === 1 && val.length === 6) {
		// スラッシュ区切りがなく6桁数値の場合
		year = val.substr(0, 2) - 0 + 2000
		month = val.substr(2, 2) - 0
		day = val.substr(4, 2) - 0
	} else {
		return null
	}
	if (year < 1000) {
		year += 2000
	}

	// 分解した年月日からDateオブジェクトを生成
	var date = new Date(year, month - 1, day)
	// 生成したDateオブジェクトの各値と分解した値が同じかチェック
	if (date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day) {
		return date
	} else {
		return null
	}
}
/**
 * 指定されたフォーマットで日付を文字列に変換する.
 * @param {Date} date 文字列化する日付
 * @param {String} format フォーマット
 * @return {String} フォーマットした文字列
 */
export function formatDate (date, format = "YYYY/MM/DD") {
	// 引数dateがDate型でない場合nullを返す
	if (toString.call(date).indexOf("Date") === -1) return null

	let result = format
	if (result.indexOf("YYYY") !== -1) {
		result = result.replace("YYYY", (date.getFullYear() + "").padStart(4, "0"))
	}
	if (result.indexOf("MM") !== -1) {
		result = result.replace("MM", ((date.getMonth() + 1) + "").padStart(2, "0"))
	}
	if (result.indexOf("DD") !== -1) {
		result = result.replace("DD", (date.getDate() + "").padStart(2, "0"))
	}
	if (result.indexOf("HH") !== -1) {
		result = result.replace("HH", (date.getHours() + "").padStart(2, "0"))
	}
	if (result.indexOf("MI") !== -1) {
		result = result.replace("MI", (date.getMinutes() + "").padStart(2, "0"))
	}
	if (result.indexOf("SS") !== -1) {
		result = result.replace("SS", (date.getSeconds() + "").padStart(2, "0"))
	}
	if (result.indexOf("MS") !== -1) {
		result = result.replace("MS", (date.getMilliseconds() + "").padStart(2, "0"))
	}

	return result
}

export function debounce (func, wait) {
	let timeout
	return function (...args) {
		const context = this
		clearTimeout(timeout)
		timeout = setTimeout(() => {
			func.apply(context, args)
		}, wait)
	}
}
